module.exports = __webpack_public_path__ + "img/sun-cloud-raining.c1b5a2bd.svg";